import React from 'react';

import styled from 'styled-components';

import {
  IconChevronRight,
  Image,
  TextLink,
  Type,
  gray60,
  white,
} from '@spotify-internal/encore-creator-web';

import { VSpacer24 } from '../../../Elements';

const iconSrc = 'https://misc.scdn.co/covid-support/Covid-icon.png';

const logoSrc = 'https://misc.scdn.co/covid-support/Spotify-logo.png';

const title = 'COVID-19 support';

const heading = 'Make a contribution';

const subheading = "Visit the artist's fundraising choice";

const Row = styled.div`
  display: flex;
  align-items: flex-start;
`;

const Heading = styled(Type).attrs({
  as: Type.h4,
  color: white,
  variant: Type.heading4,
})`
  font-size: 16px;
  padding-bottom: 0;

  &::after {
    content: '';
    display: block;
    border-bottom: 3px solid transparent;
    transition: border-color 200ms ease-in;
  }
`;

const RowSpaceBetween = styled(TextLink)`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  &:focus ${Heading} {
    &::after {
      border-color: ${white};
    }
  }

  &&& {
    text-decoration: none;

    &:hover {
      text-decoration: none;
    }
  }
`;

const Column = styled(Row)`
  flex-direction: column;
`;

const Icon = styled(Image).attrs({ height: 80 })`
  margin-right: 16px;
  min-height: 80px;
  min-width: 80px;
`;

const Logo = styled(Image).attrs({ height: 24 })`
  margin-right: 8px;
  min-height: 24px;
  min-width: 24px;
`;

export const Title = styled(Type).attrs({
  as: Type.h3,
})`
  color: ${gray60};
  margin-bottom: 5px;
  padding-bottom: 0;
`;

const Subheading = styled(Type).attrs({
  as: Type.p,
  color: gray60,
})`
  padding-bottom: 0;
`;

export const PreviewLinkIcon = styled(IconChevronRight).attrs({
  color: gray60,
  iconSize: 24,
})`
  align-self: center;
`;

type Props = { url: string };

export function ArtistFundraisingPickUpdateBody(props: Props) {
  function PreviewLink({ children }: { children: React.ReactElement }) {
    return (
      <RowSpaceBetween href={props.url} target="preview-link">
        {children}
      </RowSpaceBetween>
    );
  }

  return (
    <>
      <PreviewLink>
        <>
          <Row>
            <Icon src={iconSrc} alt="" />

            <Column>
              <Title>
                <Logo src={logoSrc} alt="" />
                {title}
              </Title>

              <Heading>{heading}</Heading>

              <Subheading>{subheading}</Subheading>
            </Column>
          </Row>

          <Column style={{ justifySelf: 'flex-end', alignSelf: 'center' }}>
            <PreviewLinkIcon aria-hidden focusable={false} />
          </Column>
        </>
      </PreviewLink>
      <VSpacer24 />
    </>
  );
}
